import React from 'react';
import { MenuStyles } from './MenuStyles';
import { navigationData } from '../../constants';
import { Link } from 'react-router-dom';
import { useAppSelector } from '../../state/hooks';

function Menu({ active, handleMenu, setActive }: {active: boolean, handleMenu: () => void, setActive: () => void}) {
  const { interfaceLanguage } = useAppSelector((state) => state.languages);

  return (
    <MenuStyles className={active ? 'active' : ''}>
      <div className="container">
        <ul>
          {navigationData(interfaceLanguage).map((item) => <li onClick={setActive} key={item.path}><Link to={`/${interfaceLanguage}${item.path}`}>{item.name}</Link></li>)}
        </ul>

        {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
        <button className="closeMenuButton" onClick={() => handleMenu()} type="button" />
      </div>
    </MenuStyles>
  );
}

export default Menu;
